import { render } from "./portal-save-changes-confirmation.vue?vue&type=template&id=63574194"
import script from "./portal-save-changes-confirmation.vue?vue&type=script&lang=js"
export * from "./portal-save-changes-confirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__